import { Component, OnInit ,HostListener} from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from 'src/services/general.service';
import { SweetAlertService } from 'src/services/sweet-alert.service';
import { timer } from 'rxjs';
declare var svg:any;
@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['./index.component.scss']
})
export class IndexComponent  {
  data: any;
  bann: any;
  boton: any;

  timeLeft: number = 60;
  interval:any
  subscribeTimer:any
  // Tiempo local de renovación
  localTimer = 1000;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;
eventos: any;
  constructor(private router: Router, private service: GeneralService,private alertas:SweetAlertService) {
    this.countDown();
   }


  ngOnInit(): void {
    if (localStorage.getItem('token')) {
      this.boton = 1;
    }
    this.service.verNoticias(531457).subscribe(res => {
      this.data = res.body;
      console.log(this.data);

    })
    this.service.verBanner(531457).subscribe(res => {
      this.bann = res.body;
      console.log(this.bann);

    })
    svg();

 this.service.verEVENTOS(531457).subscribe(res => {
      this.eventos = res.body;
      console.log(this.eventos);

    })


  }




  noticia1() {
    this.router.navigate(['admin/ver-noticia/1'])
  }

  noticia2() {
    this.router.navigate(['admin/ver-noticia/2'])
  }

  noticia3() {
    this.router.navigate(['admin/ver-noticia/3'])
  }
  noticia4() {
    this.router.navigate(['admin/ver-noticia/4'])
  }
  noticia5() {
    this.router.navigate(['admin/ver-noticia/5'])
  }

  noticia6() {
    this.router.navigate(['admin/ver-noticia/6'])
  }

  editar() {
    this.router.navigate(["admin/editar-banner"])
  }

  subirNoticia() {
    this.router.navigate(['admin/subir-noticia']);
  }




  pauseTimer() {
    clearInterval(this.subscribeTimer);
  }


  countDown() {
    this.isActivity = true;
    clearInterval(this.isMouseMove);

    this.isMouseMove = setInterval(() => {
      this.countRefresh = 0;
      this.isActivity = false;
    }, this.localTimer);

    if (this.isActivity && this.countRefresh === 1) {
      // se refresca sesion
      console.log('refresh');
    }else{

    }

    this.countRefresh++;
  }
  /**
   * Evento que escucha cuando el mouse se encuentra en movimiento
   * @param {MouseEvent} e - evento cuando el mouse esta en movimiento
   */

}
